// Desktop hover-to-open for Dawn header dropdowns (details/summary)
document.addEventListener('DOMContentLoaded', () => {
  const mq = window.matchMedia('(min-width: 990px)');
  const nav = document.querySelector('.header__inline-menu');
  if (!nav) return;

  const detailsList = Array.from(nav.querySelectorAll('details'));

  const closeAll = (except = null) => {
    detailsList.forEach(d => {
      if (d !== except) d.removeAttribute('open');
    });
  };

  const onEnter = (details) => {
    if (!mq.matches) return;
    closeAll(details);
    details.setAttribute('open', '');
  };

  const onLeave = (details) => {
    if (!mq.matches) return;
    details.removeAttribute('open');
  };

  detailsList.forEach(details => {
    details.addEventListener('mouseenter', () => onEnter(details));
    details.addEventListener('mouseleave', () => onLeave(details));
  });

  // If you leave the whole nav, close everything
  nav.addEventListener('mouseleave', () => {
    if (!mq.matches) return;
    closeAll();
  });
});